<template>
  <div
    class="message-location"
    :class="{ 'message-location--clickable': locationContent }"
    @click="handleCopyLocation"
  >
    <div class="message-location__title">{{ title }}</div>
    <div v-if="locationContent" class="message-location__address">{{ locationContent }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { ElMessage } from 'element-plus'
import utils from '@/utils'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      title: '',
      content: ''
    })
  }
})

const title = computed(() => props.message.title || '')
const locationContent = computed(() => props.message.content || '')

const handleCopyLocation = () => {
  if (!title.value) return

  utils.copyToClipboard(
    title.value,
    () => {
      ElMessage.success('复制成功')
    },
    () => {
      ElMessage.error('复制失败')
    }
  )
}
</script>

<style lang="scss" scoped>
.message-location {
  width: 240px;
  padding: 12px;
  color: #323233;
  background: #fff;
  border: 1px solid #f2f3f5;
  border-radius: 8px;
}

.message-location--clickable {
  cursor: pointer;
}

.message-location__title {
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-location__address {
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  color: #969799;
  word-break: break-all;
}
</style>
